import FJAppLeft from '../../../FJMainPreview/FJAppLeft/FJAppLeft.jsx';
import FJGenerateButton from '../../../../common/components/FJGenerateButton/FJGenerateButton.jsx';
import PropTypes from 'prop-types';
import { useRef } from 'react';
import FJAIAudioGeneratorData from '../../../../config/dataConfig/FJAIAudioGeneratorData.js';
import FJTitleLine from '../../../../common/combineComponents/FJTitleLine/FJTitleLine.jsx';
import FJLocalStore from '../../../../store/FJLocalStore.js';
import FJAudioUpload from '../../../../common/combineComponents/FJAudioUpload/FJAudioUpload.jsx';
import styles from './FJAIAudioLeft.module.less';
import FJTextAreaWithLyric from '../../../../common/combineComponents/FJTextAreaWithLyric/FJTextAreaWithLyric.jsx';
import MicrophoneIcon from '../../../../assets/svg/microphone.svg?react';
import FJVerticalScroller from '../../../../common/components/FJScroller/FJVerticalScroller.jsx';
import FJUtil from '../../../../util/FJUtil.js';
import FJTextAreaWidthInspire from '../../../../common/combineComponents/FJTextAreaWidthInspire/FJTextAreaWidthInspire.jsx';
import { AI_AUDIO_USE_CREDIT } from '../../../../redux/slices/FJSliceAIAudioGenerator.js';

const FJAIAudioLeft = props => {
    const {
        tabIndex,
        onGenerate,
        taskStatus,
        freeNumCreation,
        isProjectLoading,
        creditNumber,
        prompt,
        onChangePrompt,
    } = props;
    const {
        uploadAudioFile,
        audioInfo,
        uploadAudioStatus,
        uploadVocalAudioFile,
        vocalAudioInfo,
        uploadVocalAudioStatus,
        lyricContent,
        onLyricContentChange,
        onLyricDescChange,
        lyricDesc,

        clearAudioInfo,
        clearVocalAudioInfo,
        clearIncidentalAudioInfo,
        uploadIncidentalAudioFile,

        incidentalAudioInfo,
        uploadIncidentalAudioStatus,

        generateLyrics,
        isGenerateLyricsLoading,

        setIsDraggingFile,
        isDraggingFile,
        onRecordClick,

        isDraggingVoiceFile,
        setIsDraggingVoiceFile,

        onUseSampleInIncidentalFile,
        onUseSampleInAudioFile,
        onUseSampleInVoiceFile,

        getInspire,

        openMediaLibraryByIncidentalAudio,
        openMediaLibraryByAudio,
        openMediaLibraryByVocalAudio,
    } = props;

    const isFree = freeNumCreation > 0 && creditNumber < AI_AUDIO_USE_CREDIT;

    const renderLyricsLength = () => {
        return <div className={styles.length}>{FJUtil.getByteLen(lyricContent)}/350</div>;
    };

    return (
        <FJAppLeft style={{ paddingLeft: 0 }} className={styles.app_left}>
            <FJVerticalScroller className={styles.scroll_box}>
                <div style={{ width: '435px', marginLeft: 21 }}>
                    {tabIndex === 0 && (
                        <>
                            <FJTitleLine
                                title={FJLocalStore._('reference-music')}
                                desc={FJLocalStore._('please-upload-an-audio-containing-vocals-and-background-music')}
                                isRequire={true}
                                onUseSample={onUseSampleInAudioFile}
                                style={{ marginTop: 0 }}
                            />
                            <FJAudioUpload
                                uploadFile={uploadAudioFile}
                                audioInfo={audioInfo}
                                uploadStatus={uploadAudioStatus}
                                onDelete={clearAudioInfo}
                                isDraggingFile={isDraggingFile}
                                setIsDraggingFile={setIsDraggingFile}
                                openMediaLibrary={openMediaLibraryByAudio}
                            />
                            <FJTitleLine
                                title={FJLocalStore._('reference-vocal')}
                                desc={FJLocalStore._('please-upload-or-record-an-acapella-audio')}
                                onUseSample={onUseSampleInVoiceFile}
                            />
                            <div className={styles.content_box}>
                                <FJAudioUpload
                                    uploadFile={uploadVocalAudioFile}
                                    audioInfo={vocalAudioInfo}
                                    uploadStatus={uploadVocalAudioStatus}
                                    onDelete={clearVocalAudioInfo}
                                    isDraggingFile={isDraggingVoiceFile}
                                    setIsDraggingFile={setIsDraggingVoiceFile}
                                    className={styles.box}
                                    config={{ width: 250, height: 22 }}
                                    uploadDesc={FJLocalStore._('upload-singing-voice')}
                                    openMediaLibrary={openMediaLibraryByVocalAudio}
                                />
                                <div className={styles.record} onClick={onRecordClick}>
                                    <MicrophoneIcon />
                                </div>
                            </div>
                            <FJTitleLine
                                title={FJLocalStore._('lyrics')}
                                desc={FJLocalStore._('you-can-use-line-breaks-to-separate-each-line-of-lyrics')}
                                isRequire={true}
                                isShowTry={false}
                                renderRight={renderLyricsLength}
                            />
                            <FJTextAreaWithLyric
                                placeholder={FJLocalStore._('textarea-placeholder')}
                                text={lyricContent}
                                onChange={onLyricContentChange}
                                onDescChange={onLyricDescChange}
                                descText={lyricDesc}
                                generateLyrics={generateLyrics}
                                isGenerateLyricsLoading={isGenerateLyricsLoading}
                            />
                        </>
                    )}
                    {tabIndex === 1 && (
                        <>
                            <FJTitleLine
                                title={FJLocalStore._('reference-music')}
                                desc={FJLocalStore._('please-upload-an-audio-of-at-least-15s')}
                                isRequire={true}
                                onUseSample={onUseSampleInIncidentalFile}
                                style={{ marginTop: 0 }}
                            />
                            <FJAudioUpload
                                uploadFile={uploadIncidentalAudioFile}
                                audioInfo={incidentalAudioInfo}
                                uploadStatus={uploadIncidentalAudioStatus}
                                onDelete={clearIncidentalAudioInfo}
                                isDraggingFile={isDraggingFile}
                                setIsDraggingFile={setIsDraggingFile}
                                ket='incidental'
                                openMediaLibrary={openMediaLibraryByIncidentalAudio}
                            />
                        </>
                    )}
                    {tabIndex === 2 && (
                        <>
                            <FJTitleLine
                                title={FJLocalStore._('prompt')}
                                desc={FJLocalStore._(
                                    'please-describe-the-sound-effect-you-want-to-generate-with-a-maximum-of-200-characters',
                                )}
                                isRequire={true}
                                isShowTry={false}
                                style={{ marginTop: 0 }}
                            />
                            <FJTextAreaWidthInspire
                                hasGuide={false}
                                hasInspireInReight={true}
                                placeholder={FJLocalStore._('describe-the-sound-effect-you-want-to-generate')}
                                getInspire={getInspire}
                                text={prompt}
                                onChange={onChangePrompt}
                                maxByteLength={200}
                            />
                        </>
                    )}
                </div>
            </FJVerticalScroller>

            <div style={{ paddingLeft: 21 }}>
                <FJGenerateButton
                    onClick={onGenerate}
                    taskStatus={taskStatus}
                    freeNumCreation={freeNumCreation}
                    isFree={isFree}
                    useCredit={AI_AUDIO_USE_CREDIT}
                    isProjectLoading={isProjectLoading}
                    style={{ marginTop: '24px' }}
                    isShowUsageDetail={true}
                />
            </div>
        </FJAppLeft>
    );
};

FJAIAudioLeft.propTypes = {
    currentRatio: PropTypes.string,
    changeRatio: PropTypes.func,
    onChangeQuality: PropTypes.func,
    onChangeDuration: PropTypes.func,
    currentQuality: PropTypes.number,
    currentDuration: PropTypes.number,
    tabIndex: PropTypes.number,
    onChangeTabIndex: PropTypes.func,
    originImage: PropTypes.object,
    textValue: PropTypes.string,
    onTextValueChange: PropTypes.func,
    uploadFile: PropTypes.func,
    isDraggingFile: PropTypes.bool,
    setIsDraggingFile: PropTypes.func,
    uploadStatus: PropTypes.string,
    getInspire: PropTypes.func,
    showAIImageHistoryList: PropTypes.func,
    onFileDelete: PropTypes.func,

    onGenerate: PropTypes.func,
    taskStatus: PropTypes.string,
    freeNumCreation: PropTypes.number,
    creditNumber: PropTypes.number,
    peopleImageInfo: PropTypes.object,
    clothesImageInfo: PropTypes.object,
    onUploadImage: PropTypes.func,
    selectedStyle: PropTypes.string,
    onSelectStyle: PropTypes.func,
    isProjectLoading: PropTypes.bool,

    uploadAudioFile: PropTypes.func,
    audioInfo: PropTypes.object,
    uploadAudioStatus: PropTypes.string,
    uploadVocalAudioFile: PropTypes.func,
    vocalAudioInfo: PropTypes.object,
    uploadVocalAudioStatus: PropTypes.string,
    lyricContent: PropTypes.string,
    onLyricContentChange: PropTypes.func,
    onLyricDescChange: PropTypes.func,
    lyricDesc: PropTypes.string,

    clearAudioInfo: PropTypes.func,
    clearVocalAudioInfo: PropTypes.func,
    clearIncidentalAudioInfo: PropTypes.func,
    uploadIncidentalAudioFile: PropTypes.func,

    incidentalAudioInfo: PropTypes.object,
    uploadIncidentalAudioStatus: PropTypes.string,

    generateLyrics: PropTypes.func,
    isGenerateLyricsLoading: PropTypes.bool,

    isDraggingVoiceFile: PropTypes.bool,
    setIsDraggingVoiceFile: PropTypes.func,

    onRecordClick: PropTypes.func,
    onUseSampleInIncidentalFile: PropTypes.func,
    onUseSampleInAudioFile: PropTypes.func,
    onUseSampleInVoiceFile: PropTypes.func,
    prompt: PropTypes.string,
    onChangePrompt: PropTypes.func,

    openMediaLibraryByIncidentalAudio: PropTypes.func,
    openMediaLibraryByAudio: PropTypes.func,
    openMediaLibraryByVocalAudio: PropTypes.func,
};
export default FJAIAudioLeft;
